import React, { useEffect, useState } from "react";
import ApiKeyForm from "./ApiKeyForm";
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission } from '../../../sc-utilities';
import { parseURL } from "../../../sc-utilities";
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from '../store/securazeApiActions';
import History from "../../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const ApiKeyEdit = props => {
    const { classes, apiKey, onFetchApiKey, onFetchApiKeyInit, activeCustomerID, translations, permissions, onEditApiKey } = props;
    const [data, setData] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await onFetchApiKey({ ActiveCustomerID: activeCustomerID, ApiKeyID: parseURL(window.location.href).ApiKeyID })
            setData(false)
        }
        fetchData();
        return () => {
            onFetchApiKeyInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        data["ApiKeyID"] = apiKey.ApiKeyID;
        let result = await onEditApiKey({ ...data, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack()
        }
    };

    let initialValues = {
        ApiKey: apiKey.ApiKey || "",
    };

    let formSettings = {
        Validation: {
            ApiKey: Yup.string().required("Required"),
        },
        FormTitle: translations["edit_api_key"] || "Edit API key",
        ButtonSubmit: hasPermission(permissions, "api_key_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >
                <img alt="App logo loading" className={classes.logo} src={process.env.PUBLIC_URL + '/assets/images/app-logo-loading.gif'} />
            </Dialog>
            {!data ?
                <ApiKeyForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    translations={translations}
                />
                : <CircularProgress
                    variant="static"
                    color="primary"
                    size={28}
                />}
        </Paper>
    );
};
const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        apiKey: state.setting.securazeAPI && state.setting.securazeAPI.loaded ? state.setting.securazeAPI.loaded : {},
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchApiKeyInit: apiKey => dispatch(actions.loadApiKeyInit(apiKey)),
        onFetchApiKey: apiKey => dispatch(actions.loadApiKey(apiKey)),
        onEditApiKey: apiKey => dispatch(actions.editApiKey(apiKey)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ApiKeyEdit));
